const GREGORIAN_MONTHS =
  /^(January|February|March|April|May|June|July|August|September|October|November|December)$/i;

const ISLAMIC_LOCALES = [
  "en-US-u-ca-islamic-umalqura-nu-latn",
  "ar-SA-u-ca-islamic-umalqura",
  "en-US-u-ca-islamic-nu-latn",
  "en-TN-u-ca-islamic-nu-latn",
  "en-SA-u-ca-islamic-nu-latn",
  "ar-SA-u-ca-islamic",
] as const;

const HIJRI_MONTHS_ROMAN = [
  "Muharram",
  "Safar",
  "Rabi al-Awwal",
  "Rabi al-Thani",
  "Jumada al-Awwal",
  "Jumada al-Thani",
  "Rajab",
  "Sha'ban",
  "Ramadan",
  "Shawwal",
  "Dhu al-Qadah",
  "Dhu al-Hijjah",
] as const;

function toLatinDigits(value: string) {
  return value
    .replace(/[\u0660-\u0669]/g, (ch) => "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669".indexOf(ch).toString())
    .replace(/[\u06F0-\u06F9]/g, (ch) => "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9".indexOf(ch).toString());
}

function parseNumericPart(parts: Intl.DateTimeFormatPart[], type: Intl.DateTimeFormatPartTypes) {
  const raw = parts.find((p) => p.type === type)?.value?.trim() || "";
  const normalized = toLatinDigits(raw).replace(/[^\d]/g, "");
  const parsed = Number.parseInt(normalized, 10);
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatRomanHijriDate(date: Date, timeZone = "Asia/Karachi") {
  for (const locale of ISLAMIC_LOCALES) {
    const longFormatter = new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone,
    });

    // Skip locales where this runtime falls back to Gregorian.
    if (!longFormatter.resolvedOptions().calendar.includes("islamic")) {
      continue;
    }

    const longParts = longFormatter.formatToParts(date);
    const dayNum = parseNumericPart(longParts, "day");
    const yearNum = parseNumericPart(longParts, "year");
    const era = longParts.find((p) => p.type === "era")?.value?.trim() || "";

    const monthNumberParts = new Intl.DateTimeFormat(locale, {
      month: "numeric",
      timeZone,
    }).formatToParts(date);
    const monthNum = parseNumericPart(monthNumberParts, "month");
    const monthName =
      monthNum && monthNum >= 1 && monthNum <= 12
        ? HIJRI_MONTHS_ROMAN[monthNum - 1]
        : "";

    const fallbackMonth = longParts.find((p) => p.type === "month")?.value?.trim() || "";
    const safeMonth =
      monthName ||
      (fallbackMonth && !GREGORIAN_MONTHS.test(fallbackMonth) ? fallbackMonth : "");

    const isValidIslamic =
      safeMonth &&
      dayNum !== null &&
      yearNum !== null &&
      !/^(BC|BCE)$/i.test(era);

    if (isValidIslamic) {
      return `${dayNum} ${safeMonth} ${yearNum} AH`;
    }
  }

  return "";
}
